import SocialLinks from '@components/social-links'

import styles from './footer.module.scss'

import type { JSX } from 'react'

export default function Footer(): JSX.Element {
  return (
    <div className={styles.footer}>
      <div className={styles.social}>
        <h3>Follow us</h3>
        <SocialLinks theme="dark" />
      </div>
    </div>
  )
}
